
import { COMPROBANTE_RETENCION_TYPES } from '../constants/comprobanteRetencion.types'
import { comprobanteRetencionInitialState } from '../initital-state/comprobanteRetencion.state'
import { ComprobanteRetencion, ComprobanteRetencionAction, ComprobanteRetencionState, } from '../interfaces/comprobante-retencion.interface'

const comprobanteRetencionReducer = (
  state: ComprobanteRetencion = comprobanteRetencionInitialState,
  action: ComprobanteRetencionAction
): ComprobanteRetencionState => {
  switch (action.type) {
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_SET_CATALOGO_SUCURSAL:
      return {...state, catalogoSucursal: action.payload, sucursalesCargadas: true}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_SET_CATALOGO_SERIE:
      return {...state, catalogoSerie: action.payload}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FORMCLIENTE_HANDLE_CHANGE:
      return {...state, formCliente: {...state.formCliente, ...action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FORMCLIENTE_SET_ERRORS:
      return {...state, errorsFormCliente: {...state.errorsFormCliente, ...action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FORMSUCURSAL_HANDLE_CHANGE:
      return {...state, formSucursal: {...state.formSucursal, ...action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FORMSUCURSAL_SET_ERRORS:
      return {...state, errorsFormSucursal: {...state.errorsFormSucursal, ...action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_ARRAYPRODUCTOS_EDIT:
      const array = state.arrayProductos.map((producto, i) => i === state.productoSeleccionado ? state.formProductosEdit : producto)
      return { ...state, arrayProductos: array, modals: {...state.modals, activeEditar: false}, formProductosEdit: comprobanteRetencionInitialState.formProductosEdit, errorsFormProductosEdit: comprobanteRetencionInitialState.errorsFormProductosEdit, }
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_ARRAYPRODUCTOS_SELECT_ONE:
      return {...state, productoSeleccionado: action.payload}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_ARRAYPRODUCTOS_DELETE_ONE:
      return { ...state, arrayProductos: [ ...state.arrayProductos.filter((_, i) => i !== state.productoSeleccionado!), ], }

    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_ARRAYPRODUCTOS_SET_CALCULOS:
      return { ...state, calculosArrayProductos: {...state.calculosArrayProductos, ...action.payload}, }
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_CLEAR_ALL:
      let datosEmisor = !action.payload ? state.datosEmisor : {}
      return {...comprobanteRetencionInitialState, datosEmisor}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_SET_DATOS_EMISOR:
      return {...state, datosEmisor: {...state.datosEmisor, ...action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_SET_DATOS_FACTURA:
      return {...state, datosFacturaRes: {...state.datosFacturaRes, ...action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_SET_UUID:
      return {...state, datosUUID: {...state.datosUUID, ...action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FACTURA_EMITIDA:
      return {...state, facturaEmitda: action.payload}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_OPCIONES_ACTIVA:
      return {...state, opcionesActiva: true}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALELIMINAR_OPEN:
      return {...state, modals: {...state.modals, ...action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALELIMINAR_CLOSE:
      return {...state, modals: comprobanteRetencionInitialState.modals, productoSeleccionado: null}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALFACTURACION_OPEN:
      return {...state, modals: {...state.modals, ...action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALEDITAR_OPEN:
      return {...state, modals: {...state.modals, activeEditar: true}, ...action.payload}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALEDITAR_CLOSE:
      return { ...state, modals: {...state.modals, activeEditar: false}, formProductosEdit: comprobanteRetencionInitialState.formProductosEdit, errorsFormProductosEdit: comprobanteRetencionInitialState.errorsFormProductosEdit, }
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALIMPRESION_OPEN:
      return {...state, modals: {...state.modals, activeImpresion: action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALEMAIL_OPEN:
      return {...state, modals: {...state.modals, activeEmail: action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALANULAR_OPEN:
      return {...state, modals: {...state.modals, activeAnular: action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_ANULADO:
      return {...state, anulado: action.payload}

    // DOCUMENTOS
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_SETOPEN: 
      return {...state, modalDocumentos: {...comprobanteRetencionInitialState.modalDocumentos, user: state.modalDocumentos.user, form: {...comprobanteRetencionInitialState.modalDocumentos.form}, errorForm: {...comprobanteRetencionInitialState.modalDocumentos.errorForm}, open: action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_FORM_HANDLECHANGE: 
      return {...state, modalDocumentos: {...state.modalDocumentos, form: {...state.modalDocumentos.form, ...action.payload}}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_ADD_ERRORS: 
      return {...state, modalDocumentos: {...state.modalDocumentos, errorForm: {...state.modalDocumentos.errorForm, ...action.payload}}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_SET_LOADER: 
      return {...state, modalDocumentos: {...state.modalDocumentos, loader: action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_SET_DOCUMENTOS: 
      return {...state, modalDocumentos: {...state.modalDocumentos, documentos: action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_SET_USER: 
      return {...state, modalDocumentos: {...state.modalDocumentos, user: action.payload}}


    // ASOCIAR DOCUMENTOS
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_DOCUMENTO_ASOCIAR: 
      return {...state, documentosAsociados: [...state.documentosAsociados, action.payload]}
      // DESASOCIAR DOCUMENTOS
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_DOCUMENTO_DESASOCIAR: 
      let documentosAsociados = state.documentosAsociados.filter((el) => el.numDocumento !== action.payload)
    return {...state, documentosAsociados}
      // DESASOCIAR TODOS DOCUMENTOS
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_ARRAYPRODUCTOS_CLEAR_ALL:
      return {...state, documentosAsociados: []}

    // DOCUMENTOS FÍSICO
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_HANDLE_CHANGE: 
    return {...state, fisico: {...state.fisico, form: {...state.fisico.form, ...action.payload}}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_ADD_ERRORS: 
      return {...state, fisico: {...state.fisico, errorForm: {...state.fisico.errorForm, ...action.payload}}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_MODAL_SETOPEN: 
      return {...state, fisico: {...state.fisico, open: action.payload, edit: false}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_SETEDIT: 
      return {...state, fisico: {...state.fisico, edit: action.payload}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_CLEAR: 
      return {...state, fisico: {...state.fisico, form: comprobanteRetencionInitialState.fisico.form, errorForm: comprobanteRetencionInitialState.fisico.errorForm}}
    case COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_EDITAR_DOC: {
      const doc = action.payload
      const array = state.documentosAsociados.map((documento:any) => documento?.id === doc?.id ? doc : documento)
      return {...state, documentosAsociados: array}
    }

    default:
      return state
  }
}

export default comprobanteRetencionReducer
